export const useModal = (dialogs) => {
  function open(key){
    dialogs[key] = true
    setTimeout(() => {
      document.documentElement.classList.add('isModalOpen')
      document.documentElement.classList.add('isOverflow')
    }, 1);
  }

  function close(key){
    dialogs[key] = false
    document.documentElement.classList.remove('isModalOpen')
    setTimeout(() => {
      document.documentElement.classList.remove('isOverflow')
    }, 300);
  }

  return {
    open,
    close
  }
}